import { Button, Drawer, PageActionButtonComponentBaseProps, Tooltip } from '@chronosphereio/chrono-ui';
import { Layers as LayersIcon } from 'mdi-material-ui';
import { useState } from 'react';
import { EventDefinition } from '../../../core';
import { DASHBOARD_TOOLTIP_TEXT } from '../../constants';
import { useEditMode, useEventStoreContext } from '../../context';
import { EventEditor } from './EventsEditor';

export function useDashboardEventsDrawer() {
  const [isEventsDrawerOpen, setIsEventsDrawerOpen] = useState(false);
  const { setEditMode } = useEditMode();

  const openEventsDrawer = () => {
    setIsEventsDrawerOpen(true);
    setEditMode(true);
  };

  const closeEventsDrawer = () => {
    setIsEventsDrawerOpen(false);
  };

  return {
    isEventsDrawerOpen,
    openEventsDrawer,
    closeEventsDrawer,
  };
}

export function EditEventsButton({ buttonType }: Pick<PageActionButtonComponentBaseProps, 'buttonType'>) {
  const { isEventsDrawerOpen, openEventsDrawer, closeEventsDrawer } = useDashboardEventsDrawer();

  return (
    <>
      <Tooltip Content={DASHBOARD_TOOLTIP_TEXT.editEvents}>
        <Button
          StartIcon={<LayersIcon />}
          onClick={openEventsDrawer}
          aria-label={DASHBOARD_TOOLTIP_TEXT.editEvents}
          variant="tertiary"
          buttonType={buttonType}
          sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
        >
          Events
        </Button>
      </Tooltip>
      <DashboardEventsDrawer isOpen={isEventsDrawerOpen} onClose={closeEventsDrawer} />
    </>
  );
}

export function DashboardEventsDrawer({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { eventDefinitions, setEventDefinitions } = useEventStoreContext();

  return (
    <Drawer open={isOpen} onClose={onClose} data-testid="event-editor">
      <EventEditor
        eventDefinitions={eventDefinitions}
        onCancel={onClose}
        onChange={(events: EventDefinition[]) => {
          setEventDefinitions(events);
          onClose();
        }}
      />
    </Drawer>
  );
}
